export default "__VITE_ASSET__DWD$ulhG__"